import { FC, PropsWithChildren } from "react";
import { TextSubtitle } from "../../typography/TextSubtitle";

export const SonnerTitle: FC<PropsWithChildren> = ({ children }) => (
  <TextSubtitle
    size={2}
    data-component="SonnerTitle"
    isResponsive={false}
  >{ children }</TextSubtitle>
);
